import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RadMonitorActions from './rad-monitor.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';


@Injectable({
  providedIn: 'root'
})
export class RadMonitorStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new RadMonitorActions.RadMonitorRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RADMONITOR, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RadMonitorActions.RadMonitorCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RadMonitorActions.RadMonitorUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RadMonitorActions.RadMonitorDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RadMonitorActions.RadMonitorRefresh());
      }
    });

  }
}
